import React from "react";
import ReactModal from "react-modal";

// TypeScript 5.x has stricter JSX component type checking
// This wrapper ensures Modal works with the newer type system
const TypedModal = React.forwardRef<ReactModal, ReactModal.Props>(
  (props, ref) => {
    // Cast to any to bypass the strict type checking while maintaining functionality
    const ModalComponent = ReactModal as any;
    return <ModalComponent {...props} ref={ref} />;
  }
);

TypedModal.displayName = "TypedModal";

// Add static methods from ReactModal
(TypedModal as any).setAppElement = ReactModal.setAppElement;

// Set the app element for accessibility (prevents modal from being hidden from screen readers)
if (typeof window !== "undefined" && window.document && window.document.getElementById("root")) {
  ReactModal.setAppElement("#root");
}

export default TypedModal;